export const KLACHT_TYPES = [
  { code: 'Reiniging_Niet_OK', label: 'Reiniging niet OK' },
  { code: 'Schade_Cinco', label: 'Schade door Cinco' },
  { code: 'Schade_Bestaand_Disclaimer', label: 'Schade bestaand (disclaimer)' },
  { code: 'Te_Laat', label: 'Te laat' },
  { code: 'Verkeerd_Item', label: 'Verkeerd item' },
  { code: 'Communicatie', label: 'Communicatie' },
  { code: 'Pricing', label: 'Pricing' },
  { code: 'Anders', label: 'Anders' },
] as const;

export const KLACHT_REDENEN = [
  'Los vuil',
  'Vlekken',
  'Looppad',
  'Geur',
  'Pluis',
  'Geparfumeerde geur',
  'Algemeen vuil',
  'Cinco schade veroorzaakt',
  'Kleuruitloop',
  'Franje',
  'Ondertapijt',
  'Anders',
] as const;

export const KLANT_VERWACHT_OPTIES = [
  { code: 'Herreiniging', label: 'Herreiniging' },
  { code: 'Refund_Volledig', label: 'Volledige terugbetaling' },
  { code: 'Refund_Gedeeltelijk', label: 'Gedeeltelijke terugbetaling' },
  { code: 'Coulance_Tegoed', label: 'Coulance-tegoed' },
  { code: 'Excuses_Geen_Actie', label: 'Alleen excuses, geen actie' },
  { code: 'Schadeclaim', label: 'Schadeclaim' },
] as const;

export type KlachtActionType =
  | 'Refund'
  | 'NewWerkOrder'
  | 'InvoiceAdjust'
  | 'CoulanceVoucher'
  | 'NoAction';

export const ACTION_TYPES: ReadonlyArray<{
  code: KlachtActionType;
  label: string;
  icon: string;
}> = [
  { code: 'Refund', label: 'Refund (Mollie/Bank/Tegoed/Factuur)', icon: '💸' },
  { code: 'NewWerkOrder', label: 'Nieuwe ophaal-WO', icon: '🚐' },
  { code: 'InvoiceAdjust', label: 'Factuur aanpassen', icon: '📋' },
  { code: 'CoulanceVoucher', label: 'Coulance-tegoed', icon: '🎁' },
  { code: 'NoAction', label: 'Alleen excuses (geen actie)', icon: '💬' },
];

export const KLACHT_STATUSES = [
  { code: 'Geregistreerd', label: 'Geregistreerd', color: 'bg-amber-100 text-amber-800 border border-amber-200' },
  { code: 'In_Behandeling', label: 'In behandeling', color: 'bg-blue-100 text-blue-800 border border-blue-200' },
  { code: 'Wacht_op_Klant', label: 'Wacht op klant', color: 'bg-purple-100 text-purple-800 border border-purple-200' },
  { code: 'Opgelost', label: 'Opgelost', color: 'bg-green-100 text-green-800 border border-green-200' },
  { code: 'Gesloten', label: 'Gesloten', color: 'bg-slate-100 text-slate-700 border border-slate-200' },
] as const;

export const REFUND_METHODES = [
  { code: 'Mollie', label: 'Mollie (origineel betaald via Mollie)' },
  { code: 'Bank', label: 'Bankoverschrijving (handmatig)' },
  { code: 'Coulance_Tegoed', label: 'Verrekenen met coulance-tegoed' },
  { code: 'Factuur_Correctie', label: 'Op factuur corrigeren' },
] as const;

export const REFUND_STATUSES = [
  { code: 'Pending', label: 'Pending', color: 'bg-amber-100 text-amber-800 border border-amber-200' },
  { code: 'Verwerkt', label: 'Verwerkt', color: 'bg-green-100 text-green-800 border border-green-200' },
  { code: 'Mislukt', label: 'Mislukt', color: 'bg-red-100 text-red-800 border border-red-200' },
] as const;

export const OPEN_KLACHT_STATUSES = ['Geregistreerd', 'In_Behandeling', 'Wacht_op_Klant'] as const;
export const CLOSED_KLACHT_STATUSES = ['Opgelost', 'Gesloten'] as const;

export function klachtStatusLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return KLACHT_STATUSES.find((s) => s.code === code)?.label ?? code;
}

export function klachtStatusColor(code: string | null | undefined): string {
  if (!code) return 'bg-slate-100 text-slate-700 border border-slate-200';
  return (
    KLACHT_STATUSES.find((s) => s.code === code)?.color ??
    'bg-slate-100 text-slate-700 border border-slate-200'
  );
}

export function klachtTypeLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return KLACHT_TYPES.find((t) => t.code === code)?.label ?? code;
}

export function klantVerwachtLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return KLANT_VERWACHT_OPTIES.find((o) => o.code === code)?.label ?? code;
}

export function refundMethodeLabel(code: string | null | undefined): string {
  if (!code) return '—';
  return REFUND_METHODES.find((m) => m.code === code)?.label ?? code;
}

export function refundStatusColor(code: string | null | undefined): string {
  if (!code) return 'bg-slate-100 text-slate-700 border border-slate-200';
  return (
    REFUND_STATUSES.find((s) => s.code === code)?.color ??
    'bg-slate-100 text-slate-700 border border-slate-200'
  );
}

export function isOpenKlachtStatus(code: string | null | undefined): boolean {
  return !!code && (OPEN_KLACHT_STATUSES as readonly string[]).includes(code);
}
